'use client';

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useRef } from 'react';
import { selectAuthUser } from '@/features/auth';
import { useAppSelector } from '@/store/hooks';
import { usePainelBaixarProcesso } from '../hooks/usePainelBaixarProcesso';
import type { PortaDosAutos } from '../types/baixarProcesso.types';
import { BaixarProcessoDrawer } from './BaixarProcessoDrawer';
import { BaixarProcessoMenu } from './BaixarProcessoMenu';
interface BaixarProcessoAcaoContainerProps {
  processoId: string;
  numeroProcesso: string;
  /**
   * `escritorio` traz o menu de formato do cabeçalho; `secretaria` monta só o painel, aberto pela
   * ação do menu dela (`painelAbertoParaEscolherFormato`), e fala com as rotas admin.
   */
  porta?: PortaDosAutos;
  /** Para onde o foco volta ao fechar o painel, quando o gatilho não é o menu daqui. */
  retornoDoFoco?: RefObject<HTMLElement | null>;
}
export function BaixarProcessoAcaoContainer(t0) {
  const $ = _c(50);
  const {
    processoId,
    numeroProcesso,
    porta: t1,
    retornoDoFoco
  } = t0;
  const porta = t1 === undefined ? "escritorio" : t1;
  let t2;
  if ($[0] !== porta || $[1] !== processoId) {
    t2 = {
      porta,
      processoId
    };
    $[0] = porta;
    $[1] = processoId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const painel = usePainelBaixarProcesso(t2);
  const usuario = useAppSelector(selectAuthUser);
  const gatilhoDoMenu = useRef(null);
  const emailDeAviso = usuario?.email ?? "seu e-mail cadastrado";
  let t3;
  if ($[3] !== painel || $[4] !== porta) {
    t3 = porta === "escritorio" ? <BaixarProcessoMenu aberto={painel.menuAberto} gatilhoRef={gatilhoDoMenu} onAbertoChange={aberto => aberto ? painel.trocarFormato() : painel.fecharMenu()} onEscolherFormato={painel.escolherFormato} /> : null;
    $[3] = painel;
    $[4] = porta;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== painel) {
    t4 = arquivo => void painel.baixarArquivo(arquivo);
    $[6] = painel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = retornoDoFoco ?? gatilhoDoMenu;
  let t6;
  if ($[8] !== emailDeAviso || $[9] !== numeroProcesso || $[10] !== painel.alternarSecao || $[11] !== painel.alternarTodasAsSecoes || $[12] !== painel.arquivoEmPreparo || $[13] !== painel.avisoDaSelecao || $[14] !== painel.cancelarGeracao || $[15] !== painel.carregandoRegistro || $[16] !== painel.carregandoSecoes || $[17] !== painel.continuarComFormato || $[18] !== painel.continuarEsperando || $[19] !== painel.darCiencia || $[20] !== painel.enviandoCiencia || $[21] !== painel.erroGeracao || $[22] !== painel.escolherSecoes || $[23] !== painel.etapa || $[24] !== painel.falhaNoRegistro || $[25] !== painel.falhouPorLimite || $[26] !== painel.fecharPainel || $[27] !== painel.formato || $[28] !== painel.formatoEmEscolha || $[29] !== painel.gerar || $[30] !== painel.marcarFormato || $[31] !== painel.pacote || $[32] !== painel.pacoteJaGerado || $[33] !== painel.painelAberto || $[34] !== painel.reaproveitado || $[35] !== painel.recarregarRegistro || $[36] !== painel.registroDeAnexos || $[37] !== painel.secoes || $[38] !== painel.secoesMarcadas || $[39] !== painel.segundosParaDecidir || $[40] !== painel.tentarNovamente || $[41] !== painel.trocarFormato || $[42] !== painel.voltarParaSelecao || $[43] !== porta || $[44] !== t4 || $[45] !== t5) {
    t6 = <BaixarProcessoDrawer aberto={painel.painelAberto} porta={porta} arquivoEmPreparo={painel.arquivoEmPreparo} avisoDaSelecao={painel.avisoDaSelecao} carregandoRegistro={painel.carregandoRegistro} carregandoSecoes={painel.carregandoSecoes} emailDeAviso={emailDeAviso} enviandoCiencia={painel.enviandoCiencia} erroGeracao={painel.erroGeracao} falhaNoRegistro={painel.falhaNoRegistro} etapa={painel.etapa} falhouPorLimite={painel.falhouPorLimite} formato={painel.formato} formatoEmEscolha={painel.formatoEmEscolha} numeroProcesso={numeroProcesso} onAlternarSecao={painel.alternarSecao} onAlternarTodas={painel.alternarTodasAsSecoes} onBaixarArquivo={t4} onCancelarGeracao={painel.cancelarGeracao} onContinuarComFormato={painel.continuarComFormato} onContinuarEsperando={painel.continuarEsperando} onDarCiencia={painel.darCiencia} onEscolherSecoes={painel.escolherSecoes} onFechar={painel.fecharPainel} onGerar={painel.gerar} onMarcarFormato={painel.marcarFormato} onRecarregarRegistro={painel.recarregarRegistro} onTentarNovamente={painel.tentarNovamente} onTrocarFormato={painel.trocarFormato} onVoltarParaSelecao={painel.voltarParaSelecao} pacote={painel.pacote} pacoteJaGerado={painel.pacoteJaGerado} reaproveitado={painel.reaproveitado} registroDeAnexos={painel.registroDeAnexos} retornoDoFoco={t5} secoes={painel.secoes} secoesMarcadas={painel.secoesMarcadas} segundosParaDecidir={painel.segundosParaDecidir} />;
    $[8] = emailDeAviso;
    $[9] = numeroProcesso;
    $[10] = painel.alternarSecao;
    $[11] = painel.alternarTodasAsSecoes;
    $[12] = painel.arquivoEmPreparo;
    $[13] = painel.avisoDaSelecao;
    $[14] = painel.cancelarGeracao;
    $[15] = painel.carregandoRegistro;
    $[16] = painel.carregandoSecoes;
    $[17] = painel.continuarComFormato;
    $[18] = painel.continuarEsperando;
    $[19] = painel.darCiencia;
    $[20] = painel.enviandoCiencia;
    $[21] = painel.erroGeracao;
    $[22] = painel.escolherSecoes;
    $[23] = painel.etapa;
    $[24] = painel.falhaNoRegistro;
    $[25] = painel.falhouPorLimite;
    $[26] = painel.fecharPainel;
    $[27] = painel.formato;
    $[28] = painel.formatoEmEscolha;
    $[29] = painel.gerar;
    $[30] = painel.marcarFormato;
    $[31] = painel.pacote;
    $[32] = painel.pacoteJaGerado;
    $[33] = painel.painelAberto;
    $[34] = painel.reaproveitado;
    $[35] = painel.recarregarRegistro;
    $[36] = painel.registroDeAnexos;
    $[37] = painel.secoes;
    $[38] = painel.secoesMarcadas;
    $[39] = painel.segundosParaDecidir;
    $[40] = painel.tentarNovamente;
    $[41] = painel.trocarFormato;
    $[42] = painel.voltarParaSelecao;
    $[43] = porta;
    $[44] = t4;
    $[45] = t5;
    $[46] = t6;
  } else {
    t6 = $[46];
  }
  let t7;
  if ($[47] !== t3 || $[48] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[47] = t3;
    $[48] = t6;
    $[49] = t7;
  } else {
    t7 = $[49];
  }
  return t7;
}